export enum IFilesViewerEvents {
    OPENED = 'file-viewer@opened',
    CLOSED = 'file-viewer@closed',
    BONDED = 'file-viewer@bonded',
    UNBOUNDED = 'file-viewer@unbounded',
    SLIDE_OPENED = 'file-viewer@slide-opened',
}
